import { createReducer } from '@reduxjs/toolkit';

import getJobsInProgress from '../../thunks/jobs/getJobsInProgress';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const getJobsInProgressReducer = createReducer(initialState, {
  [getJobsInProgress.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getJobsInProgress.fulfilled]: (state, { payload: { data, total, ...props } }) => ({
    ...state,
    loading: false,
    data,
    total,
    ...props
  }),
  [getJobsInProgress.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getJobsInProgressReducer;
